export class FeatureAliasMapper {
  static aliases: Map<string, string> = new Map<string, string>();

  public static addAlias(featureId: string, alias: string) {
    this.aliases.set(featureId, alias);
  }

  public static mapText(text: string) {
    let replacedText = text;
    this.aliases.forEach((value, key) => {
      let regEx = new RegExp(key, "g");
      replacedText = replacedText.replace(regEx, value);
    });
    return replacedText;
  }
}
